import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import WhatsApp from "./components/WhatsApp";
import Footer from "./components/Footer";
import ChatBot from "./components/Chatbot";

export default function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />     {/* ✅ FIXED POSITION */}
      <Services />
      <Projects />
      <Contact />
      <WhatsApp />
      <Footer /> 
      <ChatBot/>
    </>
  );
}